import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import { demoOrderingEnvironment } from '../../utils/demoOrderingEnvironment';

export default function DistributorDemoNotice({ user }) {
  const t = useT();
  if (user?.role !== 'master_distributor' || !demoOrderingEnvironment()) return null;
  return (
    <p
      role="note"
      className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900"
    >
      {t('Demonstration workspace. Orders and payments are disabled.')}
    </p>
  );
}
